import { Model } from "pinia-orm";
import Marker from "./Marker";

export default class Building extends Model {
  static entity = "aos_buildings";
  static primaryKey = "uuid";
  static aosType = "BUILDING";

  static typeKey = "buildingType";

  static types() {
    return {
      BUILDING_FUSION: BuildingFusion,
    };
  }

  static fields() {
    return {
      uuid: this.uid(""),
      label: this.attr(null),
      type: this.attr([]),
      usage: this.attr([]),
      surface: this.attr(null),
      numberOfFloors: this.attr(null),
      isPresenceBasement: this.boolean(false),
      isPresenceCrawlspace: this.boolean(false),
      heatingMode: this.attr([]),
      occupationPresence: this.attr(null),
      occupationPresentPerson: this.attr([]),
      occupationQuantity: this.attr(null),
      isPublicReception: this.boolean(false),
      state: this.attr(null),
      soilType: this.attr([]),
      slabCondition: this.attr(null),
      access: this.attr(null),
      remarks: this.attr(null),
      isAccessible: this.boolean(false),
      reason: this.attr(null),
      typology: this.attr("BUILDING"),
      pictureUuid: this.attr(null),
      tagsType: this.attr([]),
      marker: this.morphOne(Marker, "markable_id", "markable_type"),
      temporality: this.attr(null),
      tracerCompound: this.attr([]),
      analyticalStandard: this.attr(null),
      quantificationLimit: this.attr(null),
      isSourceTakenIntoAccount: this.boolean(true),
      justification: this.attr(null),
      removalDate: this.attr(null),
      reference: this.attr(null),
      isAsbestosRisk: this.boolean(false),
      ceilingHeight: this.attr(null),
      existenceOfAConstraint: this.boolean(false),
      constraintAccuracy: this.attr(null),
      incertitudeDescription: this.attr(null),
      incertitudeCategory: this.attr(null),
    };
  }
}

export class BuildingFusion extends Building {
  static entity = "buildingFusions";
  static primaryKey = "uuid";
  static baseEntity = "aos_buildings";

  static fields() {
    return {
      ...super.fields(),
      buildings: this.attr([]),
      buildingType: this.string("BUILDING_FUSION"),
    };
  }
}
